import Model from "./Model";

export const FileUploadKinds = ["media", "client_place"];

export class FileUpload extends Model {
  kind!: string;
  status!: string;
  metadata!: string;
  createdAt?: string;
}
